import React, { useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { Modal } from 'react-bootstrap';
import { Modal as AntModal } from 'antd';
import '../Privacy.css';

const ViewUploadedPdf = (props) => {
  const { show, doc, closeModal, fileType } = props;
  const [loading, setLoading] = useState(true);
  const [numPages, setNumPages] = useState(null);

  // Determine if the document is an image
  const isImage = () => {
    if (fileType) {
      return fileType.startsWith('image/');
    }
    return /\.(jpg|jpeg|png|gif|svg|webp)/i.test(doc);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF:', error);
    setLoading(false);
  };

  return (
    <AntModal
      title=""
      footer={false}
      centered
      className="sm_modal1"
      visible={show}
      onCancel={closeModal}
      zIndex={2000}
      width={800}
    >
      <Modal.Body
        className={`view_pdf ${loading && " d-flex justify-content-center align-items-center"}`}
        style={{ maxHeight: '70vh', overflowY: 'auto' }}
      >
        {loading && (
          <div className="snippet" data-title="dot-elastic">
            <div className="stage">
              <div className="dot-elastic"></div>
            </div>
          </div>
        )}
        {doc && (
          isImage() ? (
            <div className="text-center">
              <img
                src={doc}
                alt="Uploaded Policy"
                style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }}
                onLoad={() => setLoading(false)}
              />
            </div>
          ) : (
            <div className="text-center">
              <Document
                file={doc}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
                loading={null}
                error={
                  <div className="text-danger">
                    Failed to load PDF. Please try again.
                  </div>
                }
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    width={700}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                ))}
              </Document>
            </div>
          )
        )}
      </Modal.Body>
      <Modal.Footer className="submit_button_margin">
        <div className="mt-4">
          <button
            type="button"
            onClick={closeModal}
            className="btn btn-primary cm_btn2"
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </AntModal>
  );
};

export default ViewUploadedPdf;
